import { useEffect, useRef } from "react";

import { useAppSubmitting } from "../hooks/useAppSubmitting";
import { useLogin, useUser } from "../hooks/useAuth";
import { apiClient } from "../utils/api";

/**
 * Component that handles automatic login when isAppSubmitting is true
 * and the user is not logged in. Uses credentials from environment variables.
 * Never runs when a session already exists (React Query user or persisted client user).
 */
const AutoLoginHandler: React.FC = () => {
  const { isAppSubmitting } = useAppSubmitting();
  const { data: user } = useUser();
  const loginMutation = useLogin();
  const hasAttemptedLogin = useRef(false);

  useEffect(() => {
    if (!isAppSubmitting) {
      hasAttemptedLogin.current = false;
      return;
    }

    const existingSession = user ?? apiClient.getUserData();
    if (existingSession) return;

    if (hasAttemptedLogin.current || loginMutation.isPending) return;

    const email = process.env.REACT_APP_AUTO_LOGIN_USERNAME;
    const password = process.env.REACT_APP_AUTO_LOGIN_PASSWORD;
    if (!email || !password) return;

    hasAttemptedLogin.current = true;
    loginMutation.mutate({ email, password });
  }, [isAppSubmitting, user, loginMutation]);

  return null;
};

export default AutoLoginHandler;
